var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkformsColored = function SvgWorkformsColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 20,
    fill: "none",
    viewBox: "0 0 15 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_642_352343)",
    fillRule: "evenodd",
    d: "M2.885 0a2.885 2.885 0 0 0 0 5.77h9.23a2.885 2.885 0 0 0 0-5.77zm0 6.92a2.885 2.885 0 0 0 0 5.77h5.192a2.885 2.885 0 0 0 0-5.77z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_642_352343)",
    fillRule: "evenodd",
    d: "M5.77 2.885a2.885 2.885 0 1 1-5.77 0 2.885 2.885 0 0 1 5.77 0m0 6.92a2.885 2.885 0 1 1-5.77 0 2.885 2.885 0 0 1 5.77 0m-2.885 9.81a2.885 2.885 0 1 0 0-5.77 2.885 2.885 0 0 0 0 5.77",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_642_352343",
    x1: -5.192,
    x2: 1.082,
    y1: -4.326,
    y2: 18.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0B76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58A25",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_642_352343",
    x1: 2.308,
    x2: 16.418,
    y1: -1.154,
    y2: 21.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C21E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5948",
    stopOpacity: 0.457
  })))));
};
export default SvgWorkformsColored;